import {
  HostEnvironment,
  PaldeskRemoteVersions,
} from '@paldesk/module-federation/core';
import { HeaderTestRemoteVersion } from '@paldesk/module-federation/remotes-registry';

export class EnvironmentBase {
  static remotes: PaldeskRemoteVersions = {
    ...HeaderTestRemoteVersion,
  };

  static google_analytics_id = '';
  static google_maps_api_key = '';
  static environment: HostEnvironment = 'test';
  static palfinger_api_management = '';
  static palfinger_api_management_subs_key = '';
  static palfinger_app_gateway = '';
  static oidc_clientid = '';
  static oidc_scope = '';
  static env = '';
  static cpq_domain = '';
  static jobplanner_domain = '';
  static whitelistedEmbededDomains: string[];
  static domainsForApiManagementSubsKey: string[];
  static jobplannerLocalUrl = '';
  static palfinger_palshow_api = '';
  static application_insights_key = '';
  static buildId = '';
  static disable_spotlights = false;
  static identityServerAuthConf: {
    whitelistedDomains: string[];
    whitelistedRoutes: string[];
    blacklistedRoutes: string[];
  } = {
    whitelistedDomains: [],
    whitelistedRoutes: [],
    blacklistedRoutes: [],
  };
  static cpqAccessoryMapping = {};
  static validCraneBaseParts: string[] = [];
  /**
   * Where the GLazor engine (CalcApps.PALSHOW.GLazor, `index.html` + `_framework/`) is served from.
   * Empty means "not hosted for this environment": the page shows an error instead of the diagram.
   * A `current.txt` next to this folder overrides the folder at page load (`glazor-current-build.ts`).
   */
  static glazorBuildBaseUrl = '';
  static LINKS: {
    SECURITY_TOKEN_SERVICE: string;
    POST_LOGOUT_REDIRECT_URI: string;
    PALDESK_BASEPATH: string;
    APP_HELP_PATH: string;
    APP_NEWS_PATH: string;
    STATUS_PALDESK_PAGE: string;
  } = {
    SECURITY_TOKEN_SERVICE: '',
    POST_LOGOUT_REDIRECT_URI: '',
    PALDESK_BASEPATH: '',
    APP_HELP_PATH: '',
    APP_NEWS_PATH: '',
    STATUS_PALDESK_PAGE: '',
  };
}
